import { gql } from '@urql/core';
import React from 'react';
import { Content_Media_Link_Type_Enum, VoDsCardFragment } from '../../generated/spin-graphql';
import { ExternalLink } from '../common/ExternalLink';

type Props = {
    vods: VoDsCardFragment[];
};

gql`
    fragment VODsCard on espin_player_vod {
        id
        label
        media_link {
            id
            link_data
            link_type
        }
    }
`;

export const VODsCard: React.FC<Props> = ({ vods }) => {
    return (
        <div className="profile-card dark-theme">
            <div className="title-container">
                <h2 className="title">VODs</h2>
                <div className="links">
                    {vods.map((vod, index: number) => {
                        let linkPrefix = 'https://www.youtube.com/watch?v=';

                        if (vod.media_link.link_type === Content_Media_Link_Type_Enum.TwitchVideo) {
                            linkPrefix = 'https://www.twitch.tv/videos/';
                        } else if (vod.media_link.link_type === Content_Media_Link_Type_Enum.TwitchClip) {
                            linkPrefix = '';
                        }

                        return (
                            <ExternalLink
                                key={`vod-link-${index}`}
                                className="link"
                                link={`${linkPrefix}${vod.media_link.link_data}`}
                                ariaLabel={vod.label}
                                label={vod.label}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
